import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import GoogleAuth from '../components/GoogleAuth';
import UserRegistrationForm from '../components/UserRegistrationForm';
import { useAuth } from '../contexts/AuthContext';

const LoginPage = () => {
  const { isAuthenticated, user, needsRegistration, login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // ログイン成功時のリダイレクト先を決定
  const redirectTo = location.state?.from || '/uploader';

  useEffect(() => {
    if (isAuthenticated && user && !needsRegistration) {
      navigate(redirectTo, { replace: true });
    }
  }, [isAuthenticated, user, needsRegistration, navigate, redirectTo]);

  // ログイン済みの場合はリダイレクトされるため、この表示は不要

  if (isAuthenticated && needsRegistration) {
    return (
      <div style={{ padding: '20px' }}>
        <h1>ログイン実験ページ - プロフィール登録</h1>
        <UserRegistrationForm />
      </div>
    );
  }

  return (
    <div style={{ padding: '20px', textAlign: 'center' }}>
      <h1>ログイン実験ページ</h1>
      <p>このページでGoogleログインの実験を行います。</p>
      <GoogleAuth 
        onAuthSuccess={(userInfo, token) => login(userInfo, token)}
        onAuthFailure={(error) => console.error('Auth failed:', error)}
      />
    </div>
  );
};

export default LoginPage;